interface MovieCard {
  title: string;
  tags: string[];
  imageSrc: string;
  imageAlt: string;
  rating: string;
  desc: string;
}

const cards: MovieCard[] = [
  {
    title: '星际远征',
    tags: ['4K', '科幻'],
    imageSrc: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20astronaut%20floating%20in%20deep%20space%2C%20distant%20galaxy%20and%20nebula%20colors%2C%20dramatic%20lighting%2C%20professional%20film%20poster%20design%2C%20dark%20background%20with%20vibrant%20cosmic%20elements&width=600&height=840&seq=mahua-card-01&orientation=portrait',
    imageAlt: '星际远征 - 4K科幻电影海报',
    rating: '9.2',
    desc: '人类探索未知星系的壮丽史诗',
  },
  {
    title: '暗夜追踪',
    tags: ['蓝光', '悬疑'],
    imageSrc: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20with%20silhouette%20figure%20in%20rainy%20city%20street%20at%20night%2C%20neon%20reflections%20on%20wet%20pavement%2C%20film%20noir%20aesthetic%2C%20dark%20moody%20atmosphere%2C%20professional%20cinema%20poster%20design&width=600&height=840&seq=mahua-card-02&orientation=portrait',
    imageAlt: '暗夜追踪 - 蓝光悬疑电影海报',
    rating: '8.8',
    desc: '雨夜都市中的致命追踪',
  },
  {
    title: '花落知多少',
    tags: ['4K', '剧情'],
    imageSrc: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20with%20cherry%20blossom%20petals%20falling%2C%20couple%20silhouette%20in%20golden%20sunset%20light%2C%20warm%20soft%20tones%2C%20poetic%20cinematic%20atmosphere%2C%20elegant%20film%20poster%20design%20with%20emotional%20mood&width=600&height=840&seq=mahua-card-03&orientation=portrait',
    imageAlt: '花落知多少 - 4K温情剧情电影海报',
    rating: '9.0',
    desc: '一段跨越时光的深情守候',
  },
  {
    title: '极限营救',
    tags: ['4K', '动作'],
    imageSrc: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20explosive%20urban%20scene%2C%20heroic%20figure%20in%20dynamic%20pose%2C%20dramatic%20fire%20and%20smoke%20effects%2C%20intense%20orange%20and%20dark%20tones%2C%20professional%20blockbuster%20film%20poster%20design&width=600&height=840&seq=mahua-card-04&orientation=portrait',
    imageAlt: '极限营救 - 4K动作电影海报',
    rating: '8.5',
    desc: '72小时生死时速紧急救援',
  },
  {
    title: '深海魅影',
    tags: ['蓝光', '恐怖'],
    imageSrc: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20mysterious%20deep%20ocean%20scene%2C%20dark%20underwater%20atmosphere%20with%20eerie%20blue-green%20lighting%2C%20subtle%20creature%20silhouette%2C%20suspenseful%20cinematic%20design%2C%20professional%20thriller%20film%20poster&width=600&height=840&seq=mahua-card-05&orientation=portrait',
    imageAlt: '深海魅影 - 蓝光恐怖电影海报',
    rating: '7.9',
    desc: '海底万米深渊的未知恐惧',
  },
  {
    title: '长安十二时辰',
    tags: ['4K', '历史'],
    imageSrc: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20epic%20movie%20poster%20with%20ancient%20Tang%20dynasty%20palace%20architecture%2C%20lanterns%20and%20traditional%20costumes%2C%20warm%20golden%20and%20crimson%20tones%2C%20grand%20cinematic%20scale%2C%20professional%20film%20poster%20design&width=600&height=840&seq=mahua-card-06&orientation=portrait',
    imageAlt: '长安十二时辰 - 4K历史电影海报',
    rating: '9.4',
    desc: '盛唐风华下的惊天阴谋',
  },
  {
    title: '动物狂想曲',
    tags: ['4K', '动画'],
    imageSrc: 'https://readdy.ai/api/search-image?query=Animated%20family%20movie%20poster%20with%20colorful%20animal%20characters%20in%20vibrant%20forest%20setting%2C%20magical%20glowing%20elements%2C%20warm%20cheerful%20atmosphere%2C%20professional%20animation%20film%20poster%20design%20with%20rich%20colors&width=600&height=840&seq=mahua-card-07&orientation=portrait',
    imageAlt: '动物狂想曲 - 4K动画电影海报',
    rating: '8.7',
    desc: '丛林伙伴们的奇妙冒险之旅',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <div className="inline-flex items-center gap-2 bg-accent-100/80 px-4 py-2 rounded-full mb-5">
              <i className="ri-star-line text-accent-600 text-sm"></i>
              <span className="text-accent-700 text-xs font-medium">编辑甄选</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              精选推荐
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
              麻花影院团队每日甄选，只为给你最棒的4K超清观影体验
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {cards.slice(0, 6).map((card) => (
              <div key={card.title} className="group cursor-pointer">
                <div className="relative rounded-xl overflow-hidden mb-3 aspect-[2/3]">
                  <img
                    src={card.imageSrc}
                    alt={card.imageAlt}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
                    {card.tags.map((tag) => (
                      <span key={tag} className="bg-black/60 backdrop-blur-sm text-white text-[10px] px-2 py-0.5 rounded-md whitespace-nowrap">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <div className="absolute top-3 right-3 bg-black/60 backdrop-blur-sm text-accent-400 text-xs font-bold px-2 py-0.5 rounded-md whitespace-nowrap">
                    {card.rating}
                  </div>
                </div>
                <h3 className="font-heading text-foreground-900 font-semibold text-sm mb-1 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-foreground-500 text-xs">{card.desc}</p>
              </div>
            ))}

            <div className="col-span-2 sm:col-span-3 lg:col-span-1 flex items-center justify-center">
              <a
                href="#index"
                className="w-full h-full min-h-[200px] border-2 border-dashed border-background-300 hover:border-primary-300 rounded-xl flex flex-col items-center justify-center gap-3 p-6 transition-all duration-300 hover:bg-primary-50/50 cursor-pointer group"
              >
                <div className="w-14 h-14 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                  <i className="ri-arrow-right-line text-primary-600 text-2xl"></i>
                </div>
                <span className="text-foreground-600 text-sm font-medium whitespace-nowrap">探索更多</span>
                <span className="text-foreground-400 text-xs">5000+ 部高清影片</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}